/** Query keys for the messaging screens. */
export const conversationKeys = {
  all: ['conversations'] as const,
  hub: () => [...conversationKeys.all, 'hub'] as const,
  unread: () => [...conversationKeys.all, 'unread'] as const,
  one: (id: string) => [...conversationKeys.all, 'one', id] as const,
  messages: (id: string) => [...conversationKeys.all, 'messages', id] as const,
  panel: (id: string) => [...conversationKeys.all, 'panel', id] as const,
};
